export const joinItemByTilde = (str1: string, str2: string) => {
  if (str1 && str2) return `${str1}～${str2}`
  if (str1) return `${str1}～`
  if (str2) return `～${str2}`
  return ""
}
